<template>
  <v-container grid-list-xl>
    <h2 class="pl-4">
      <span>Programming</span>
      <span class="green--text">Portfolio</span>
    </h2>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="1000"
        v-for="project in projects"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                :alt="project.title"
                aspect-ratio="1.7778"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-card-title class="cardTitle">
            {{project.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="project.link">{{project.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{project.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Preview</h3>
          </v-card-text>
          <v-card-media>
            <v-img contain max-height="500px" :src="project.demo_image"></v-img>
          </v-card-media>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Tags</span>
              <span class="right" >Date de publication</span>
            </h3>
            <v-chip color="green" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech3}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech4}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{project.date}}</v-chip>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: 'Programming Portfolio',
    titleTemplate: "%s ← Eldin's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          'Mathieu Baesen Programming portefolio'
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Eldin' Space" },
      { property: 'og:site_name', content: "Eldin' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://eldin.space' },
      {
        property: 'og:description',
        content:
          'Mathieu Baesen Programming portfolio'
      }
    ]
  },
  data () {
    return {
      dialog: false,
      projects: [{
        dialog: false,
        title: 'Sakugaloop (Projet Angular)',
        poster: 'https://baesen.iiens.net/CV/sakugaloop_demo.png',
        demo: false,
        demo_image: 'https://baesen.iiens.net/CV/sakugaloop_demo.png',
        href: '',
        description: 'Développement d\'un site en Angular utilisant une API externe (sakugabooru) pour afficher en boucles les vidéos favorites du compte choisi. Pour raisons d\'accessibilité, le site n\'est pas publié en ligne et seulement accessible localement à partir du dépôt git. N\'hésitez pas à tester avec un pseudo (ex : Mathxxl).',
        link: 'https://github.com/Mathxxl/sakugaloop',
        date: 'Sep. 2026',
        tech: {
          tech1: 'Angular',
          tech2: 'HTML',
          tech3: 'TypeScript'
        }
      },
      {
        dialog: false,
        title: 'Moteur Physique en C++',
        poster: 'https://baesen.iiens.net/CV/demo_moteur.png',
        demo: false,
        demo_image: 'https://baesen.iiens.net/CV/demo_moteur.png',
        href: '',
        description: 'Création d\' un moteur physique incluant des corps rigides et la détection de collisions via des volumes englobants et un découpage de l\'espace.',
        link: 'https://github.com/Mathxxl/Projet-Maths-Physiques-JV',
        date: 'Sep. 2022 - Dec. 2022',
        tech: {
          tech1: 'C++',
          tech2: 'Millington',
          tech3: 'ECS',
          tech4: 'OpenGL'
        }
      },
      {
        dialog: false,
        title: 'Résolveur de Sudoku en C++',
        poster: 'https://baesen.iiens.net/CV/sudoku.png',
        demo: false,
        demo_image: 'https://baesen.iiens.net/CV/sudoku.png',
        href: '',
        description: 'Création d\' un moteur résolveur de Sudoku simple en C++',
        link: 'https://github.com/Mathxxl/Sudoku-Solver-Cpp',
        date: 'Aug. 2023',
        tech: {
          tech1: 'C++',
          tech2: 'Backtracking',
          tech3: '',
          tech4: ''
        }
      }
      ]
    }
  }
}
</script>

<style  scoped>
.cardTitle{
  text-align: center;
  color: green ;
  font-size: x-large;
  justify-content: center;
}
.vid{
  text-align: center;
}
</style>
